import { render, staticRenderFns } from "./EventByDepartment.vue?vue&type=template&id=d25fb92e&scoped=true"
import script from "./EventByDepartment.vue?vue&type=script&lang=ts"
export * from "./EventByDepartment.vue?vue&type=script&lang=ts"
import style0 from "./EventByDepartment.vue?vue&type=style&index=0&id=d25fb92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25fb92e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemTitle})
